import { BulkQuickActionState } from '@sales-portal/domain/pricing/blocs/hooks/use-bulk-editing-core';
import {
  getQuickActionMetadata,
  PricingTableQuickAction,
} from '@sales-portal/domain/pricing/screens/management/components/pricing-table-quick-actions-popover';
import { useMemo } from 'react';

// Presentation layer for the bulk bar's quick actions: labels/shortcuts come
// from the shared metadata, the bookmark action (when offered) goes last.
export const useBulkQuickActions = ({
  bookmarkAction,
  bulkQuickActionStates,
}: {
  bookmarkAction: PricingTableQuickAction | null;
  bulkQuickActionStates: BulkQuickActionState[];
}): PricingTableQuickAction[] =>
  useMemo(() => {
    const editActions = bulkQuickActionStates.map((actionState) => ({
      ...getQuickActionMetadata(actionState.id),
      disabled: actionState.disabled,
      onSelect: actionState.onSelect,
    }));
    return bookmarkAction ? [...editActions, bookmarkAction] : editActions;
  }, [bookmarkAction, bulkQuickActionStates]);
